export default __webpack_public_path__ + "static/char-29-anr-a839e004b98e205cbc8ec8a0be8a3a64.webp";